import { gql } from '__generated__'

export const ResendPortalInvitation = gql(/* GraphQL */ `
    mutation ResendPortalInvitation($userIds: [ID!]!, $role: String!) {
        resendPortalInvitationEmail(userIds: $userIds, role: $role) {
            success
            message
        }
    }
`)

export const ResendPortalInvitationToRosterCandidates = gql(/* GraphQL */ `
    mutation ResendPortalInvitationEmailBulk(
        $rosterCandidateIds: [ID!]
        $rosterId: ID
        $candidateIds: [ID!]
    ) {
        resendPortalInvitationEmailBulk(
            rosterCandidateIds: $rosterCandidateIds
            rosterId: $rosterId
            candidateIds: $candidateIds
        ) {
            success
            message
        }
    }
`)

export const RemoveRosterCandidates = gql(/* GraphQL */ `
    mutation RemoveRosterCandidates($rosterCandidateIds: [ID!]!) {
        removeCandidatesFromRoster(rosterCandidateIds: $rosterCandidateIds) {
            success
            message
            data {
                candidateId
            }
        }
    }
`)

export const RemoveRosterCandidatesByCandidateIds = gql(/* GraphQL */ `
    mutation RemoveRosterCandidatesByCandidateIds(
        $rosterId: ID!
        $candidateIds: [ID!]!
    ) {
        removeCandidatesFromRosterByCandidateIds(
            rosterId: $rosterId
            candidateIds: $candidateIds
        ) {
            success
            message
            data {
                candidateId
            }
        }
    }
`)

export const GetJobBoardOptions = gql(/* GraphQL */ `
    query GetJobBoardOptions($rosterId: ID!) {
        roster(id: $rosterId) {
            companyOffices {
                companyOffice {
                    id
                    officeLocation {
                        value
                    }
                }
            }
            sectors {
                sector {
                    id
                    value
                }
            }
            placements {
                title {
                    id
                    value
                }
            }
            startDates {
                startDateLabel
            }
        }
    }
`)

export const GetMergeFields = gql(/* GraphQL */ `
    query GetMergeFields {
        mergeFields {
            label
            mergeKey
        }

        mergeFieldDelimiters {
            open
            close
        }
    }
`)

export const PrependRosterCandidateInternalNoteBulk = gql(`
    mutation PrependRosterCandidateInternalNoteBulk(
        $rosterCandidateIds: [ID!]
        $rosterId: ID
        $candidateIds: [ID!]
        $note: String!
    ) {
        prependRosterCandidateInternalNoteBulk(
            rosterCandidateIds: $rosterCandidateIds
            rosterId: $rosterId
            candidateIds: $candidateIds
            note: $note
        ) {
            success
            message
        }
    }
`)
